//#region src/internal/type-guards.ts
function isPlainObject(value) {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}

//#endregion
export { isPlainObject };
//# sourceMappingURL=type-guards-DHLAzjf2.js.map